export enum DocumentStatuses {
  NEW = 'new',
  PENDING_UPLOAD = 'pending_upload',
  PENDING_APPROVAL = 'pending_approval',
  APPROVED = 'approved',
  REJECTED = 'Rejected',
  INCOMPLETE = 'Incomplete',
  ACCEPTED = 'Accepted'
}
